import { render } from "./IceCreamconeo.vue?vue&type=template&id=1a0dab2e"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/IceCreamconeo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a0dab2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a0dab2e', __exports__)) {
    api.reload('1a0dab2e', __exports__)
  }
  
  module.hot.accept("./IceCreamconeo.vue?vue&type=template&id=1a0dab2e", () => {
    api.rerender('1a0dab2e', render)
  })

}


export default __exports__